import { DirektTeaser } from '@/components/DirektTeaser';
import { LabradorComponent } from '@/types/component';
import { http } from '@/utils/http';
import { MINUTE } from '@/utils/ttl';
import { DirektPost } from 'base/components/DirektTeaser';
import { useEffect, useState } from 'react';

export const LabradorDirektTeaser: LabradorComponent = ({ data, ...props }) => {
  const [posts, setPosts] = useState<DirektPost[]>([]);

  useEffect(() => {
    const getPosts = () =>
      http.get('/api/direkt').then((response) => {
        setPosts(response?.data);
      });

    getPosts();
    const id = setInterval(getPosts, MINUTE * 1000);

    return () => clearInterval(id);
  }, []);

  return (
    <DirektTeaser
      headline={data.headline || 'Direct'}
      posts={posts}
      button={{ content: 'Visa fler', href: '/direkt' }}
      {...props}
    />
  );
};
